<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="parentId" >
        <span slot="label" >
          <a-tooltip>
            父评论id<template slot="title">父评论id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.parentId"  :placeholder="$t('请输入')+'父评论id'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            商品id<template slot="title">商品id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsId"  :placeholder="$t('请输入')+'商品id'" />
      </a-form-model-item>
      <a-form-model-item prop="commentUserId" >
        <span slot="label" >
          <a-tooltip>
            评论用户ID<template slot="title">评论用户ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentUserId"  :placeholder="$t('请输入')+'评论用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="commentUserAvatar" >
        <span slot="label" >
          <a-tooltip>
            评论用户头像<template slot="title">评论用户头像</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentUserAvatar" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="commentUserNickname" >
        <span slot="label" >
          <a-tooltip>
            评论用户昵称<template slot="title">评论用户昵称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentUserNickname" :maxLength="100" :placeholder="$t('请输入')+'评论用户昵称'" />
      </a-form-model-item>
      <a-form-model-item prop="content" >
        <span slot="label" >
          <a-tooltip>
            评论内容<template slot="title">评论内容</template>
          </a-tooltip>
        </span>
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item prop="likedCount" >
        <span slot="label" >
          <a-tooltip>
            被点赞数量<template slot="title">被点赞数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.likedCount"  :placeholder="$t('请输入')+'被点赞数量'" />
      </a-form-model-item>
      <a-form-model-item prop="replayCount" >
        <span slot="label" >
          <a-tooltip>
            回复数量<template slot="title">回复数量</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.replayCount"  :placeholder="$t('请输入')+'回复数量'" />
      </a-form-model-item>
      <a-form-model-item prop="mediaUrls" >
        <span slot="label" >
          <a-tooltip>
            图片<template slot="title">图片</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.mediaUrls" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="hasVideo" >
        <span slot="label" >
          <a-tooltip>
            是否有视频<template slot="title">是否有视频</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.hasVideo"  :placeholder="$t('请输入')+'是否有视频'" />
      </a-form-model-item>
      <a-form-model-item prop="hasImage" >
        <span slot="label" >
          <a-tooltip>
            是否有图片<template slot="title">是否有图片</template>
          </a-tooltip>
        </span>
        <file-upload v-model="form.hasImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="score" >
        <span slot="label" >
          <a-tooltip>
            评分<template slot="title">评分</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.score"  :placeholder="$t('请输入')+'评分'" />
      </a-form-model-item>
      <a-form-model-item prop="isHiddenName" >
        <span slot="label" >
          <a-tooltip>
            是否匿名<template slot="title">是否匿名</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isHiddenName"  :placeholder="$t('请输入')+'是否匿名'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoodsComment, addGoodsComment, updateGoodsComment } from '@/api/goods/goodsComment'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        parentId: null,

        goodsId: null,

        commentUserId: null,

        commentUserAvatar: null,

        commentUserNickname: null,

        content: null,

        likedCount: null,

        replayCount: null,

        mediaUrls: null,

        hasVideo: null,

        hasImage: null,

        score: null,

        isHiddenName: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsId: [
          { required: true, message: '商品id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        commentUserId: [
          { required: true, message: '评论用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: '评论内容'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        parentId: null,
        goodsId: null,
        commentUserId: null,
        commentUserAvatar: null,
        commentUserNickname: null,
        content: null,
        likedCount: null,
        replayCount: null,
        mediaUrls: null,
        hasVideo: null,
        hasImage: null,
        score: null,
        isHiddenName: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsComment({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateGoodsComment(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addGoodsComment(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
